import 'animate.css';
const sedeItems = document.querySelectorAll('.sede-item');
const programaItems = document.querySelectorAll('.programa-item');
const getListItems = (target)=>{
  jQuery(`.todos`).fadeOut()

  programaItems.forEach((programaItem)=>{
    if(programaItem.classList.contains('animate__zoomIn')){
      programaItem.classList.remove('animate__zoomIn')
    }
    if (programaItem.dataset.groups==`${target}`) {
      setTimeout(()=>{
        if(!programaItem.classList.contains('animate__zoomIn')){
          programaItem.classList.add('animate__zoomIn')
        }
        jQuery(`.${target}`).fadeIn('fast')
      },300)
    }
  })
}
if(sedeItems && programaItems){
  
  sedeItems.forEach((sedeItem,index)=>{
    if(sedeItem.dataset.sede=="medellin"){
      sedeItem.classList.add('actived')
      getListItems(sedeItem.dataset.sede)
    }
    sedeItem.addEventListener('click',()=>{
      sedeItems.forEach((sedeElement)=>{
        sedeElement.classList.remove('actived')
      })
      sedeItems[index].classList.add('actived')
      getListItems(sedeItems[index].dataset.sede)
    })
  })
}